module.exports = __webpack_public_path__ + "img/71_4.bc8f9691.png";